import Color from 'color';

export default function useContrastText(hex) {
  const [red, green, blue] = Color(hex).array();
  const res = 1 - ((0.299 * red) + (0.587 * green) + (0.114 * blue)) / 255;
  return res < 0.5;
}
